import { attachPointToSku, availableSkus } from '@/entities/collection';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { VIDEO_ASPECT_RATIO } from '@/shared/lib';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { ScrollArea, Text, TextField } from '@radix-ui/themes';
import { Vector2d } from 'konva/lib/types';
import { Html } from 'react-konva-utils';

export function SkuSelect({
  target,
  onSelect,
  canvasWidth,
}: {
  canvasWidth: number;
  target: Vector2d;
  onSelect?: () => void;
}) {
  const availableSkuList = useAppSelector(availableSkus);
  const dispatch = useAppDispatch();

  const totalWidth = 300;
  const offsetY = 10;

  return (
    <>
      <Html
        groupProps={{
          x: target.x - totalWidth / 2,
          y: target.y + offsetY,
        }}
      >
        <div className="absolute w-3 h-3 rotate-45 bg-white -translate-x-1/2 -top-1.5 left-1/2"></div>
        <div className="bg-white w-[300px] p-2 rounded-lg shadow-lg relative z-10">
          <TextField.Root placeholder="Add product to a list...">
            <TextField.Slot side="right">
              <MagnifyingGlassIcon height="16" width="16" />
            </TextField.Slot>
          </TextField.Root>
          <ScrollArea className="my-2 flex-grow">
            <ul className="flex flex-col gap-2">
              {availableSkuList.length === 0 && (
                <Text
                  align="center"
                  size="1"
                  className="text-gray-400 font-medium"
                  mt="2"
                >
                  No SKU available
                </Text>
              )}
              {availableSkuList.map((variant) => (
                <li
                  key={variant.id}
                  className={
                    'hover:bg-gray-100 rounded-lg gap-2 flex items-center border-2 p-2 border-transparent hover:border-blue-400'
                  }
                  onClick={() => {
                    dispatch(
                      attachPointToSku({
                        variantIndex: variant.variantIndex,
                        point: {
                          ...target,
                          relativeX: target.x / canvasWidth,
                          relativeY:
                            (target.y * VIDEO_ASPECT_RATIO) / canvasWidth,
                        },
                      })
                    );
                    onSelect?.();
                  }}
                >
                  <img
                    className="min-w-10 w-10 h-10 object-contain "
                    src={variant.image}
                  />
                  <div className="flex-grow">
                    <Text
                      size="2"
                      className="text-ellipsis overflow-hidden line-clamp-2"
                    >
                      {variant.display_name}
                    </Text>
                    <Text size="2" weight="bold">
                      {variant.sku}
                    </Text>
                  </div>
                </li>
              ))}
            </ul>
          </ScrollArea>
        </div>
      </Html>
    </>
  );
}
